import type { Block } from '@contentful/rich-text-types'
import { clsx } from 'clsx'
import type { ReactElement, ReactNode } from 'react'

import styles from './rich-text.module.scss'

interface OlListProps extends Block {
  children?: ReactNode
}

export function OlList(props: OlListProps): ReactElement {
  return <ol className={clsx(styles.list, styles.olList)}>{props.children}</ol>
}
